const state = {
  button: "",
  click: "",
  openEditButton: false,
  openEditImage: false,
  openEditPdf: false,
  openEditRss: false,
  openEditScrolling: false,
  openEditText: false,
  openEditVideo: false,
  openEditWeather: false,
  openEditWeb: false,
  pdf: {},
};

const mutations = {
  EDITCLOSE: function (state) {
    state.openEditButton = false;
    state.openEditImage = false;
    state.openEditPdf = false;
    state.openEditRss = false;
    state.openEditScrolling = false;
    state.openEditText = false;
    state.openEditVideo = false;
    state.openEditWeather = false;
    state.openEditWeb = false;
  },
  EDITOPEN: function (state, type) {
    switch (type) {
      case "Button":
        state.openEditButton = true;
        break;
      case "Image":
        state.openEditImage = true;
        break;
      case "Pdf":
        state.openEditPdf = true;
        break;
      case "Rss":
        state.openEditRss = true;
        break;
      case "Scrolling":
        state.openEditScrolling = true;
        break;
      case "Text":
        state.openEditText = true;
        break;
      case "Video":
        state.openEditVideo = true;
        break;
      case "Weather":
        state.openEditWeather = true;
        break;
      case "Web":
        state.openEditWeb = true;
        break;
      default:
        break;
    }
  },
};

const actions = {
  editClose: ({ commit }) => {
    commit("EDITCLOSE");
  },
  editOpen: ({ commit }, type) => {
    commit("EDITOPEN", type);
  },
};

export default {
  state,
  mutations,
  actions,
};
